import jwt_decode from "jwt-decode";
import React, { useEffect, useRef, lazy, Suspense } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import PrivateRoute from "./components/common/PrivateRoute";
// Pages
import Axios from "axios";
import { Settings } from "luxon";
import CookieConsent from "react-cookie-consent";
import Loader from "./components/common/Loader";
import Notifications from "./components/common/Notifications/Notifications";
import Footer from "./components/common/layout/Footer";
import Header from "./components/common/layout/Header";
import ActivateAccount from "./components/pages/ActivateAccount/ActivateAccount";
import ConfirmEpPresence from "./components/pages/ConfirmEpPresence/ConfirmEpPresence";
import Dashboard from "./components/pages/Dashboard/Dashboard";
import FormRDSP from "./components/pages/FormRDSP/FormRDSP";
import NotFound from "./components/pages/NotFound/NotFound";
import RenewPassword from "./components/pages/RenewPassword/RenewPassword";
import UserDetail from "./components/pages/UserDetail/UserDetail";
import UserList from "./components/pages/UserList/UserList";
import { api_url } from "./config";
import { authActions } from "./context/actions/authActions";
import { constantActions } from "./context/actions/constantActions";
import { AUTH_TYPES } from "./context/reducers/authReducers";
import useStore from "./context/useStore";
// Chargé à la demande : la chaîne @react-pdf pèse plus de la moitié du bundle.
const PassOrientation = lazy(() => import("./components/pages/PassOrientation/PassOrientation"));

Settings.defaultZone = "Indian/Reunion";
// Cookie de session httpOnly : envoyé sur chaque appel API.
Axios.defaults.withCredentials = true;

var firstLoad = true;
const App = () => {
  const [state, dispatch] = useStore();
  var actions = authActions(state, dispatch);
  var c_actions = constantActions(state, dispatch);
  // Le rendu recrée `actions` ; la référence garde la dernière version pour
  // l'intercepteur, enregistré une seule fois (et retiré au démontage).
  const actionsRef = useRef(actions);
  actionsRef.current = actions;
  useEffect(() => {
    const interceptorId = Axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // 401 : session expirée → déconnexion (sauf sur l'appel de déconnexion lui-même)
        if (error.response && error.response.status === 401) {
          if (error.response.config.url !== api_url + "auth/logout") {
            actionsRef.current.logoutUser();
          }
        }
        return Promise.reject(error);
      }
    );
    return () => Axios.interceptors.response.eject(interceptorId);
  }, []);

  if (localStorage.jwtToken && firstLoad) {
    firstLoad = false;
    // Set auth token header auth
    //tools.setAuthToken(localStorage.jwtToken);
    // Decode token and get user info and exp
    const decoded = jwt_decode(localStorage.jwtToken);

    // Set user and isAuthenticated
    dispatch({
      type: AUTH_TYPES.SET_CURRENT_USER,
      payload: decoded,
    });

    // Check for expired token
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      // Logout user

      actions.logoutUser();
      // Clear current Profile
      // store.dispatch(clearCurrentProfile())
      // Redirect to login
    }
  }
  useEffect(() => {
    if (!localStorage.jwtToken) {
      Axios.get(api_url + "auth/me")
        .then((res) => {
          localStorage.setItem("jwtToken", res.data);
          const decoded = jwt_decode(res.data);
          dispatch({
            type: AUTH_TYPES.SET_CURRENT_USER,
            payload: decoded,
          });
        })
        .catch((err) => {
          actions.logoutUser();
        });
    }
    c_actions.getConstants();
  }, []);

  return (
    <Router>
      <>
        <a className="lien-evitement" href="#contenu">
          Aller au contenu
        </a>
        {/* Même cookie et même durée qu'avant : personne n'est redemandé. */}
        <CookieConsent
          location="bottom"
          buttonText="J'ai compris"
          cookieName="myAwesomeCookieName2"
          expires={150}
          disableStyles
          containerClasses="bandeau-cookies"
          contentClasses="bandeau-cookies__texte"
          buttonClasses="bandeau-cookies__bouton"
          ariaAcceptLabel="J'ai compris"
          customContainerAttributes={{ role: "region", "aria-label": "Information sur les cookies" }}
        >
          <i className="fa fa-cookie-bite" aria-hidden="true" />
          Ce site utilise un cookie de connexion pour authentifier les utilisateurs.
        </CookieConsent>
        <Header />
        <Notifications />
        <main id="contenu" className="app-main" tabIndex={-1}>
          {Object.keys(state.constants.items).length ? (
            <Suspense fallback={<Loader />}>
              <Switch>
                <Route path="/rdsp" exact component={FormRDSP} />

                <Route
                  path="/renew-password/:token/:email"
                  exact
                  component={RenewPassword}
                />
                <Route
                  path="/activate-account/:token/:email"
                  exact
                  component={ActivateAccount}
                />
                <PrivateRoute path="/" exact component={Dashboard} />
                <PrivateRoute path="/users" exact component={UserList} />
                <PrivateRoute path="/users/:id" exact component={UserDetail} />
                <PrivateRoute
                  path="/passorientation/:id"
                  exact
                  component={PassOrientation}
                />
                <Route
                  path="/ep-confirm-presence/:token/:epid"
                  exact
                  component={ConfirmEpPresence}
                />
                <Route component={NotFound} />
              </Switch>
            </Suspense>
          ) : (
            <Loader />
          )}
        </main>

        <Footer />
      </>
    </Router>
  );
};

export default App;
